var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.09739C0.5 6.64967 0.947715 7.09739 1.5 7.09739H5.4078V11C5.4078 11.5523 5.85552 12 6.4078 12H6.62057C7.17285 12 7.62057 11.5523 7.62057 11V7.09739H11.5C12.0523 7.09739 12.5 6.64967 12.5 6.09739V5.90261C12.5 5.35033 12.0523 4.90261 11.5 4.90261H7.62057V0.999999C7.62057 0.447714 7.17285 0 6.62057 0H6.4078C5.85552 0 5.4078 0.447715 5.4078 1V4.90261H1.5C0.947715 4.90261 0.5 5.35033 0.5 5.90261V6.09739Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlus);
export default __webpack_public_path__ + "static/media/ic_plus.bc8176f6419c3b267f9964a8c2e66326.svg";
export { ForwardRef as ReactComponent };